module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5c546394bc410d9f6bbe98486e362d37.gif";